import {
  BankReconciliationActionType,
  CurrencySaleRevaluationType,
} from '../bank-reconciliation';
import {
  CapitalActionTransactionSubType,
  CapitalActionTypes,
} from '../capital-action';
import { FeeActionType } from '../fee-actions';
import {
  ExpenseType,
  IncomeOrExpenseTransactionSubType,
  IncomeType,
} from '../income-and-expenses';
import { InvestmentTypes } from '../investment';
import { PartnerTransferTypes } from '../partner-transfer';
import {
  RealisationTransactionSubType,
  RealisationTypes,
} from '../realisation';
import { RealisedFXGainOrLossType } from '../realised-fx-gain-or-loss';
import { RevaluationTransactionType } from '../revaluation';
import { UnrealisedAssetFXGainOrLossType } from '../unrealised-asset-fx-gain-or-loss';
import {
  UnrealisedCashFXGainOrLossActionType,
  UnrealisedCashFXGainOrLossType,
} from '../unrealised-cash-fx-gain-or-loss';
import {
  UnrealisedFXGainOrLossSubType,
  UnrealisedFXGainOrLossType,
} from '../unrealised-fx-gain-or-loss';

export enum ActionRef {
  Investment = 'lpInvestment',
  Equalisation = 'equalisation',
  IncomeOrExpense = 'incomeOrExpense',
  CapitalAction = 'capitalAction',
  Realisation = 'realisation',
  Revaluation = 'revaluation',
  Reconciliation = 'reconciliation',
  BankAccountTransfer = 'bankAccountTransfer',
  Fees = 'fees',
  PrepaymentResolution = 'prepaymentResolution',
  UnrealisedFXGainOrLoss = 'unrealisedFXGainOrLoss',
  RealisedFXGainOrLoss = 'realisedFXGainOrLoss',
  UnrealisedEquityGainOrLoss = 'unrealisedEquityGainOrLoss',
  ForeignCurrencySaleGainOrLoss = 'foreignCurrencySaleGainOrLoss',
  UnrealisedCashFXGainOrLoss = 'unrealisedCashFXGainOrLoss',
  UnrealisedAssetFXGainOrLoss = 'unrealisedAssetFXGainOrLoss',
  SaleOfInvestment = 'saleOfInvestment',
  PartnerTransfer = 'partnerTransfer',
  ManualAction = 'manualAction',
}

export enum ActionCategory {
  Income = 'income',
  Expense = 'expense',
  Investment = 'investment',
  Realisation = 'realisation',
  ManagementFees = 'managementFees',
  CapitalActions = 'capitalActions',
  FX = 'fx',
}

export enum ActionOperationType {
  Received,
  Spent,
}

export enum ActionStatus {
  Draft = 'draft',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum ActionTypeDiscriminator {
  PreDefinedActionType = 'preDefinedActionType',
  CustomActionType = 'customActionType',
}

export type ActionType =
  | IncomeType
  | ExpenseType
  | InvestmentTypes
  | CurrencySaleRevaluationType
  | BankReconciliationActionType
  | RevaluationTransactionType
  | FeeActionType
  | RealisationTypes
  | UnrealisedFXGainOrLossType
  | UnrealisedCashFXGainOrLossActionType
  | UnrealisedAssetFXGainOrLossType
  | CapitalActionTypes
  | PartnerTransferTypes
  | CustomActionType;

export enum CustomActionType {
  CustomAction = 'customAction',
}

export const ActionTypes = {
  ...IncomeType,
  ...ExpenseType,
  ...InvestmentTypes,
  ...CurrencySaleRevaluationType,
  ...BankReconciliationActionType,
  ...RevaluationTransactionType,
  ...FeeActionType,
  ...RealisationTypes,
  ...UnrealisedFXGainOrLossType,
  ...UnrealisedCashFXGainOrLossActionType,
  ...UnrealisedAssetFXGainOrLossType,
  ...CapitalActionTypes,
  ...PartnerTransferTypes,
  ...CustomActionType,
};

export enum CreditDebitPair {
  CreditDebitPair = 'creditDebitPair',
}
export type ActionTransactionSubType =
  | RealisationTransactionSubType
  | UnrealisedFXGainOrLossSubType
  | UnrealisedCashFXGainOrLossType
  | RealisedFXGainOrLossType
  | CapitalActionTransactionSubType
  | CreditDebitPair
  | UnrealisedAssetFXGainOrLossType
  | IncomeOrExpenseTransactionSubType;

export const ActionTransactionSubTypes = {
  ...RealisationTransactionSubType,
  ...UnrealisedFXGainOrLossSubType,
  ...RealisedFXGainOrLossType,
  ...UnrealisedCashFXGainOrLossType,
  ...CapitalActionTransactionSubType,
  ...CreditDebitPair,
  ...UnrealisedAssetFXGainOrLossType,
  ...IncomeOrExpenseTransactionSubType,
};
